module.exports = "https://tutorchat.chegg.com/static/media/ic-clear-canvas.416ceb59.svg";